import { PatentListData } from "@/components/business/PatentContainer/Patent.types";

import PatentTableShellForPatentTitle from "./components/PatentTableShellForPatentTitle/PatentTableShellForPatentTitle";

type Props = {
  patentListItem: PatentListData;
  onClickMove: () => void;
};

const PatentTitleContainer = ({ patentListItem, onClickMove }: Props) => {
  return (
    <PatentTableShellForPatentTitle
      key={patentListItem.id}
      patentData={patentListItem}
      onClickMove={onClickMove}
    />
  );
};

export default PatentTitleContainer;
